import React from 'react';
import { Box, Button } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

export type PaginationButtonType = 'prev' | 'next';

interface Props {
    pageNumber: number;
    show: boolean;
    type: PaginationButtonType;
    onClick: (type: PaginationButtonType, pageNumber: number) => void;
}

const PaginationButton: React.FC<Props> = React.memo((props) => {
    const { show, pageNumber, type, onClick } = props;
    const cms = useSelector(selectCmsFromBootstrap);
    const onButtonClick = React.useCallback(() => onClick(type, pageNumber), [type, pageNumber, onClick]);

    if (!show) {
        return <Box width="160px" />;
    }

    const buttonText = type === 'next' ? cms[130706] : cms[130765];
    return (
        <Box width="160px">
            <Button
                variant="label"
                width="parent-fit"
                hierarchy="secondary"
                size="l"
                data-element-name={`activities-pagination-${type}-btn`}
                data-testid={`activities-pagination-${type}-btn`}
                onClick={onButtonClick}
                label={buttonText}
            />
        </Box>
    );
});
PaginationButton.displayName = 'PaginationButton';
export default PaginationButton;
